import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../../lib/analytics';

const getClickLabel = (element) => {
  const text = element.innerText?.replace(/\s+/g, ' ').trim();
  return text || element.getAttribute('aria-label') || element.getAttribute('data-testid') || element.href || 'Unlabelled click';
};

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', {
      path: `${location.pathname}${location.hash || ''}`,
    });
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const target = event.target.closest('a, button, [role="button"]');
      if (!target) return;

      const href = target.getAttribute('href') || '';
      const label = getClickLabel(target);
      const payload = {
        label,
        target: target.getAttribute('data-testid') || href || target.type || target.tagName.toLowerCase(),
        metadata: {
          href,
          testId: target.getAttribute('data-testid') || '',
        },
      };

      trackEvent(href.startsWith('tel:') || href.startsWith('mailto:') ? 'contact_click' : 'button_click', payload);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
};

export default AnalyticsTracker;
